/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 6/24/14
 * Time: 5:49 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var AbstractAppender = require("notificationCenter/appenders/AbstractAppender");

    var TabTitleNotification = AbstractAppender.extend({

        defaultOptions: {
            blinkInterval: 800,
            text: ""
        },

        originalTitle: "",

        initialize: function (options) {
            AbstractAppender.prototype.initialize.call(this, options);

            if(!this.isSupported()) {
                return;
            }

            this.originalTitle = document.title;
        },
        isEnabled: function () {
            return true;
        },
        isSupported: function () {
            return true;
        },
        getDefaultOptions: function () {
            return _.cloneDeep(this.defaultOptions);
        },
        notify: function (options) {
            this.clearNotificationInterval();

            if (!options.num || isNaN(options.num) || Number(options.num) === 0) {
                this.clearNotifications();
            }
            else {
                var newTitle1 = this.originalTitle;
                var newTitle2 = "(" + options.num + ") " + options.text;

                this.notificationInterval = setInterval(function () {
                    document.title = (document.title === newTitle1) ? newTitle2 : newTitle1;
                }, options.blinkInterval);
            }
        },
        clearNotificationInterval: function () {
            if (this.notificationInterval) {
                clearInterval(this.notificationInterval);
            }
        },
        clearNotifications: function () {
            document.title = this.originalTitle;
        },
        clearNotification:function(options){
        }
    });

    TabTitleNotification.options = [
        "num",
        "text",
        "blinkInterval"
    ];

    return TabTitleNotification;

});
